import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { NumberFormatDirective } from '../../directives/ArabicToEnglishDirective';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    StyleClassModule,
    TranslateModule,
    NumberFormatDirective
  ]
})
export class InputNumberComponent  implements OnInit {
  @Input() formGroup: UntypedFormGroup = new UntypedFormGroup({});
  @Input() controlName: UntypedFormControl = new UntypedFormControl();
  @Input() styleClass: string = "w-full text-sm";
  @Input() placeholder: string = "";
  @Input() conditionToFormat: boolean = false; 
  @Input() mode: string = "decimal"; 
  @Input() maxlength: number = 100; 
  @Output('onBlur') onBlur: EventEmitter<string> =new EventEmitter();


  constructor() { 
  }

  ngOnInit() {}

  onBlurEvent(event:any)
  {
      this.onBlur.emit(event);
  }


}
